import $ from 'jquery';
import moment from 'moment';
import 'bootstrap-daterangepicker';

export default class DatePickerService
{
	constructor(AppService)
	{
		this.options = {
			ranges: {
				'Last 7 Days': [moment().subtract(6, 'days'), moment()],
				'Last 30 Days': [moment().subtract(29, 'days'), moment()],
				'This Month': [moment().startOf('month'), moment().endOf('month')],
				'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
			},
			startDate: null,
			endDate: null,
			alwaysShowCalendars: true,
			linkedCalendars: false,
			showDropdowns: true,
			buttonClasses: "button",
			applyClass: "button",
			cancelClass: "secondary button",
			template: this.template,
			maxDate: moment(),
			opens: "left",
			locale: {
      			format: 'YYYY-MM-DD'
    		},
		};

		this.dateRange = AppService.dateRange;

		this.rangePicker = $('#base-range');
		this.compareRangePicker = $('#compare-range');
	}

	init()
	{
		this.options.startDate = this.dateRange.startDate;
		this.options.endDate = this.dateRange.endDate;
		this.rangeCallBack(this.dateRange.startDate, this.dateRange.endDate);
		this.rangePicker.daterangepicker(this.options, this.rangeCallBack);

		this.options.startDate = this.dateRange.compareStartDate;
		this.options.endDate = this.dateRange.compareEndDate;
		this.compareRangeCallBack(this.dateRange.compareStartDate, this.dateRange.compareEndDate);
		this.compareRangePicker.daterangepicker(this.options, this.compareRangeCallBack);
	}

	rangeCallBack(start, end)
	{
		$('#base-range span').html(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
	}

	compareRangeCallBack(start, end)
	{
		$('#compare-range span').html(start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));
	}

	get template()
	{
		return '<div class="daterangepicker dropdown-menu">' +
			'<div class="calendar left">' +
				'<label>Start Date</label>' +
				'<div class="daterangepicker_input">' +
				  '<input class="input-mini" type="text" name="daterangepicker_start" value="" />' +
				  '<i class="fa fa-calendar"></i>' +
				  '<div class="calendar-time">' +
					'<div></div>' +
					'<i class="fa fa-clock-o"></i>' +
				  '</div>' +
				'</div>' +
				'<div class="calendar-table"></div>' +
			'</div>' +
			'<div class="calendar right">' +
				'<label>End Date</label>' +
				'<div class="daterangepicker_input">' +
				  '<input class="input-mini" type="text" name="daterangepicker_end" value="" />' +
				  '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
				  '<div class="calendar-time">' +
					'<div></div>' +
					'<i class="fa fa-clock-o"></i>' +
				  '</div>' +
				'</div>' +
				'<div class="calendar-table"></div>' +
			'</div>' +
			'<div class="ranges">' +
				'<div class="range_inputs">' +
					'<button class="applyBtn" disabled="disabled" type="button"></button> ' +
					'<button class="cancelBtn" type="button"></button>' +
				'</div>' +
			'</div>' +
		'</div>';
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/services/datepicker.service.js
 **/